<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-col" v-animate="{ type: 'fadeUp', delay: 100 }">
          <h3>Who We Are</h3>
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/about">About Us</router-link></li>
            <li><router-link to="/products">Products</router-link></li>
            <li><router-link to="/events">Events</router-link></li>
            <li><router-link to="/contactus">Contact Us</router-link></li>
            <li><router-link to="/login">Log In</router-link></li>
          </ul>
        </div>
        <div class="footer-col product-list" v-animate="{ type: 'fadeUp', delay: 200 }">
          <h3>Our Products</h3>
          <ul style="font-size: 16px;line-height:2.5;">
            <li><router-link to="/products">RAW MATERIAL RELATIVE TO POLYURETHANE</router-link></li>
            <li><router-link to="/products">RAW MATERIAL RELATIVE TO SYNTHETIC LEATHER</router-link></li>
            <li><router-link to="/products">RAW MATERIAL RELATIVE TO FOOTWEAR</router-link></li>
            <li><router-link to="/products">RAW MATERIAL RELATIVE TO PLASTICIZER</router-link></li>
            <li><router-link to="/products">MACHINES</router-link></li>
          </ul>
        </div>
        <div class="footer-col" v-animate="{ type: 'fadeUp', delay: 300 }">
          <h3>Our Culture</h3>
          <ul>
            <li><a href="#">Life at Company</a></li>
            <li><a href="#">Mission, Vision & Values</a></li>
            <br>
            <li> <img src="@/assets/logo2.png" alt="QINYUAN GROUP Official Brand Logo" /> &nbsp; &nbsp;<img
                src="@/assets/logo.png" alt="QINYUAN GROUP Enterprise Trade Logo" />
            </li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom" v-animate="{ type: 'fadeUp', delay: 400 }">
        <p class="footer-address"><span>📍</span> SHANGHAI HEAD OFFICE : ADDRESS: ROOM200:5,NO.609 YINXIANG ROAD,JIADING
          DISTRICT,SHANGHAI,CHINA ZIP 201802.</p>
        <p><span>📞 </span> Contact : +86 18149795331&nbsp; &nbsp;|&nbsp; &nbsp;<span style=" vertical-align: -2px; ">📧
          </span>EMAIL : JACKNI@QINYUANCORP.CN</p>
        <p>© 2026 QINYUAN GROUP. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
}

.footer {
  padding: 80px;
  padding-left: 100px;
  background: #222;
  color: #fff;
}
.footer-grid {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 50px;
  margin-bottom: 80px;
}
.footer-grid .product-list {
  margin-left: -180px;
}
.footer-col {
  flex: 1;
  min-width: 200px;
}
.footer-col h3 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #e02020;
}
.footer-col ul {
  font-size: 18px;
  line-height: 2.2;
}
.footer-col ul li img {
  height: 50px;
}
.footer-col a:hover {
  color: #e02020;
}
.footer-bottom {
  font-size: 17px;
  color: #ccc;
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #444;
  line-height: 2;
}
.footer-bottom span {
  font-size: 22px;
}

.footer-address {
  margin-bottom: 4px;
}

a {
  color: inherit;
  text-decoration: none;
}

/* 新增移动端适配 不改动原有样式 */
@media screen and (max-width: 1200px) {
  .footer {
    padding: 60px 40px;
  }
  .footer-grid .product-list {
    margin-left: 0;
  }
}
@media screen and (max-width: 768px) {
  .footer {
    padding: 40px 20px;
  }
  .footer-grid {
    flex-direction: column;
    gap: 30px;
    margin-bottom: 40px;
  }
  .footer-col h3 {
    font-size: 18px;
  }
  .footer-col ul {
    font-size: 15px;
  }
  .footer-bottom {
    font-size: 14px;
    line-height: 1.8;
  }
  .container {
    padding: 0 15px;
  }
}
</style>